import Light from './Light'
import Container from './Container'

class Scene extends Container {
	
	constructor() {
		super();
		this.defines = {}
		this.lights  = []
		this.overrideMaterial = null;
	}

	add(obj) {
		if (obj instanceof Light) {
			this.lights.push( obj );
		}
		super.add(obj)
	}

	render(camera) {
		this._needsUpdate = false;
		super.render(camera, this);
	}
	
}

export default Scene;